// const data = {
//   id: 1,
//   title: 'Listen to the audio and fill in blank the missing word.',
//   subTitle: 'Nghe và điền từ còn thiếu vào chỗ trống.',
//   question: '',
//   audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/1edd45b5-514a-437e-a0b0-1025bde74898.mp3',
//   answers: [{ id: 1, text: 'Although they don’t have enough money, they buy a modern apartment.', answer: 'apartment' }],
// };
import audio from './audio/audio.mp3';

const data = {
  id: 1,
  title: 'Listen and fill the blank with the correct words.',
  subTitle: 'Nghe và điền từ vào chỗ trống.',
  audioUrl: audio,
  imageUrl: '',
  question: 'Who’s that? \r\n She’s my ___ ',
  // answers: 'apartment',
  answers: [
    { id: 1, answer: 'apartment', isCorrect: true },
  ],

};

export default data;
